function SentinelCommentModal($rootScope, $timeout, sentinelService) {
    return {
        redirect: 'E',
        replace: true,
        scope: {
            visit: '=?'
        },
		template: require('./comment-modal.html'),

        link: function (scope, element) {
            $timeout(function() {
                element.selectpicker();
            });

            scope.hideModal = function () {
                document.getElementById('addCommentText').value = "";
                $rootScope.$broadcast('sentinel-hide-comment-modal');
                $('#comment-modal').modal('hide');
            };

            scope.addComment = function () {
                var commentText = document.getElementById('addCommentText').value;

                sentinelService.addComment(scope.visit, commentText, $rootScope.user.id);

                this.hideModal();
            }
        }
    }
}

angular.module('sentinel').directive('sentinelCommentModal', ['$rootScope', '$timeout', 'sentinelService', SentinelCommentModal]);